import { styled } from '@mui/material/styles';
import { renderTypographyStyles } from '../../../../../base/utils';

export const StyledTimeSlots = styled('div')(
  ({ theme, $isSelected }) => `
     
     background-color: ${
       $isSelected ? `${theme.DS_palette.background.lightBlue}` : `${theme.DS_palette.primary.white}`
     };

      div  {
         margin: unset;
       }
 
       h3 {
    
         ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
          margin-bottom: ${theme.DS_spacing(['xxs'])};
           margin-top: ${theme.DS_spacing(['md'])};
       }
   
       
      div {
         grid-template-columns: repeat(3, 1fr);
          button {
            background-color: ${theme.DS_palette.primary.white} ;
            width: unset;
            color:  ${theme.DS_palette.primary.black};
          }
        }
        
     .toggle-slots-view{
    
        padding: ${theme.DS_spacing(['md'])} ${theme.DS_spacing(['xxxs'])} ${theme.DS_spacing(['xxxs'])};
        text-align: center;
        > button {
          color: ${theme.DS_palette.buttons.enabled};
           background-color: transparent ;

        }
     }
     
 
    ${theme.breakpoints.up('lg')} {
    
     padding: ${theme.DS_spacing(['xxxs'])} ${theme.DS_spacing(['md'])};
  
     div {
           grid-template-columns: repeat(4, 1fr); 
        }
     div:first-of-type {
         > h3 {
               margin-top: 0;
         }
     }
     .toggle-slots-view{
        padding: ${theme.DS_spacing(['md'])};
     }

  `,
);

export const StyledSkeletonTimeSlots = styled('div')(
  ({ theme }) => `
      display: grid;
      grid-template-columns: repeat(3, 1fr); 
      gap: ${theme.DS_spacing(['xxs'])};
      padding-top:${theme.DS_spacing(['xl'])};
      > div{
         border: 1px solid ${theme.DS_palette.border.form};
         border-radius: ${theme.DS_border.radius.dates};
         height: 48px;
         &:last-of-type {
          display: none;
         }
      }
       
     ${theme.breakpoints.up('lg')} {
      grid-template-columns: repeat(4, 1fr); 
        > div{
         &:last-of-type {
          display: block;
         }
      }
    }
`,
);

export const StyledNoFilterDatesWrapper = styled('div')(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['md'])};
     ${theme.breakpoints.up('lg')} {
     margin-top: -${theme.DS_spacing(['md'])};
    }
`,
);
